import { useEmblaCarousel } from "embla-carousel/react";
import * as React from 'react';
export default {
  useEmblaCarousel,
  React
};